/*
 * Stratus — Product Diagram leader lines (st-product-diagram.js), sections/st-product-diagram.liquid
 *
 * From 1024 the callouts sit beside the photo; this draws one sage elbow per callout, from 16px off the callout's
 * top or bottom edge (a quarter of its width in from its outer edge) to the centre of its marker, into the
 * aria-hidden SVG of the stage. Redrawn when the stage resizes and when the photo loads. Under 1024, or without JS,
 * there are no lines (the legend carries the content). No dependencies.
 */
(function () {
  'use strict';
  if (window.stProductDiagram) return; // loaded once per page, whatever the number of sections
  window.stProductDiagram = true;

  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var GAP = 16; // space-4: line end to the callout's edge
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function draw(stage) {
    var svg = stage.querySelector('[data-st-diagram-lines]');
    if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    if (!DESKTOP.matches) return;

    var box = stage.getBoundingClientRect();
    if (!box.width || !box.height) return;
    svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);

    var callouts = stage.querySelectorAll('[data-st-callout]');
    for (var i = 0; i < callouts.length; i++) {
      var callout = callouts[i];
      var marker = stage.querySelector('[data-st-marker="' + callout.getAttribute('data-st-callout') + '"]');
      if (!marker) continue;

      var c = callout.getBoundingClientRect();
      var m = marker.getBoundingClientRect();
      var mx = m.left + m.width / 2 - box.left;
      var my = m.top + m.height / 2 - box.top;
      var left = c.left - box.left;
      var right = c.right - box.left;
      var top = c.top - box.top;
      var bottom = c.bottom - box.top;
      var isLeft = callout.getAttribute('data-st-side') !== 'right';
      var ax = isLeft ? left + c.width / 4 : right - c.width / 4;
      var d;

      if (bottom + GAP <= my) {
        d = 'M' + ax + ' ' + (bottom + GAP) + 'V' + my + 'H' + mx;
      } else if (top - GAP >= my) {
        d = 'M' + mx + ' ' + my + 'H' + ax + 'V' + (top - GAP);
      } else {
        d = 'M' + (isLeft ? right + GAP : left - GAP) + ' ' + my + 'H' + mx;
      }

      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', d);
      path.setAttribute('vector-effect', 'non-scaling-stroke');
      svg.appendChild(path);
    }
  }

  function init(root) {
    var stages = (root || document).querySelectorAll('[data-st-diagram]');
    for (var i = 0; i < stages.length; i++) {
      var stage = stages[i];
      if (stage.hasAttribute('data-st-diagram-ready')) continue;
      stage.setAttribute('data-st-diagram-ready', '');

      var redraw = draw.bind(null, stage);
      if ('ResizeObserver' in window) {
        new ResizeObserver(redraw).observe(stage);
      } else {
        window.addEventListener('resize', redraw);
      }
      var images = stage.querySelectorAll('img');
      for (var j = 0; j < images.length; j++) {
        if (!images[j].complete) images[j].addEventListener('load', redraw, { once: true });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
      redraw();
    }
  }

  function redrawAll() {
    var stages = document.querySelectorAll('[data-st-diagram-ready]');
    for (var i = 0; i < stages.length; i++) draw(stages[i]);
  }

  if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', redrawAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: a re-rendered section brings a new stage.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', redrawAll);
})();
